// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","logo":"Header_logo__UsziS","badge":"Header_badge__kJdA3","badgeHighlight":"Header_badgeHighlight__8UMsA"};